import React, { useEffect, useState } from 'react'

import { Container } from './styles'

type IProps = {
  value?: any;
  onClick?: any;
  isDisabled?: boolean;
}

const Switch = ({ value, onClick, isDisabled = false }: IProps) => {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    function loadComponent() {
      if (value) setIsActive(value)
    }

    loadComponent()
  }, [value])

  const handleClick = () => {
    if (isDisabled) return
    setIsActive((state) => !state)
    if (!onClick) return
    onClick()
  }

  return (
    <Container
      isActive={isActive}
      isDisabled={isDisabled}
      onClick={handleClick}
    >
      <div />
    </Container>
  )
}

Switch.defaultProps = {
  value: false,
  onClick: null,
  isDisabled: false,
}

export default Switch
